<div class="subject-container" [ngClass]="{'masked': masked}">
    <div class="subject-wrapper">
        <ng-content></ng-content>
    </div>
</div>
